(ns basic-components.tabstrip-v2
  (:require
   [reagent.core :as r]
   [frontend.utils :as fu]))

(defn calculate-visible-elems
  [state refs] ;tabs-indexed tabs-container visible-elems]
  (let [{:keys [list-dn container-dn selected-tab-node tabstrip-dn]} @refs
        container-bounds (.getBoundingClientRect container-dn)
        container-right (.-right container-bounds)
        container-left (.-left container-bounds)
        container-width (.-width container-bounds)
        list-bounds (.getBoundingClientRect list-dn)
        list-width (.-width list-bounds)
        list-right (.-right list-bounds)
        list-left (.-left list-bounds)
        left-arrow-visible? (not= list-left container-left)
        right-arrow-visible? (and (> list-width container-width)
                                  (> (Math/abs (- list-right container-right)) 1))]

    ;;TODO: do we need to take into the calculation list-dn current scroll-left ??
    (swap! state assoc
      :left-arrow-visible? left-arrow-visible?
      :right-arrow-visible? right-arrow-visible?)))

(defn scroll-right
  [state refs]
  (let [{:keys [container-dn list-dn]} @refs
        container-bounds (.getBoundingClientRect container-dn)
        container-right (.-right container-bounds)
        container-width (.-width container-bounds)
        container-scroll-x (.-scrollLeft container-dn)
        list-bounds (.getBoundingClientRect list-dn)
        list-width (.-width list-bounds)
        first-partly-hidden-width (->> list-dn
                                       (.-children)
                                       (array-seq)
                                       (map (fn [tab-dom]
                                              (let [bounds (.getBoundingClientRect tab-dom)
                                                    tab-right (.-right bounds)
                                                    tab-left (.-left bounds)
                                                    left-visible? (< tab-left container-right)
                                                    right-not-visible? (>= tab-right container-right)]
                                                (when (and left-visible? right-not-visible?)
                                                  (- tab-right container-right)))))
                                       (remove nil?)
                                       (first))

        new-scroll-x (+ container-scroll-x container-width)
        new-scroll-x (cond (> new-scroll-x (- list-width container-width))
                           (- list-width container-width)
                           (number? first-partly-hidden-width)
                           (- new-scroll-x first-partly-hidden-width)
                           :else
                           new-scroll-x)]
    (.scrollTo container-dn
               (clj->js
                {"top"      0
                 "left"     new-scroll-x
                 "behavior" "smooth"}))

    (js/setTimeout (fn []
                     (calculate-visible-elems state refs))
                   500)))

(defn scroll-left
  [state refs]
  (let [{:keys [container-dn list-dn]} @refs
        container-bounds (.getBoundingClientRect container-dn)
        container-width (.-width container-bounds)
        container-scroll-x (.-scrollLeft container-dn)
        new-scroll-x (- container-scroll-x container-width)
        new-list-left (max new-scroll-x 0)]
    (.scrollTo container-dn
               (clj->js
                {"top"      0
                 "left"     new-list-left
                 "behavior" "smooth"}))
    (js/setTimeout (fn []
                     (calculate-visible-elems state refs))
                   500)))


(defn on-resize-handler
  [state refs _]
  (let [resize-timeout (:resize-timeout @refs)]
    (when resize-timeout
      (js/clearTimeout resize-timeout))
    (swap! refs assoc
      :resize-timeout
      (js/setTimeout (fn [_]
                       (calculate-visible-elems state refs)
                       200)))))

;; TODO - if default-tab-key is not needed, it can be removed
(defn component
  [{:keys [on-change! tabs selected-tab-key default-tab-key tab-strip-id dont-scroll-into-view?]}]
  (let [state (r/atom {})
        refs (atom {})
        resize-handler (partial on-resize-handler state refs)]
    (r/create-class
     {:component-did-mount    (fn [_]
                                (let [tab-dom-nodes (some-> (:list-dn @refs)
                                                            .-children
                                                            array-seq)
                                      selected-tab-label (->> tabs
                                                              (filter (fn [t]
                                                                        (= (:tab-key t) selected-tab-key)))
                                                              (first)
                                                              :tab-label)

                                      selected-tab-node (->> tab-dom-nodes
                                                             (filter (fn [tab]
                                                                       (= selected-tab-label (.-textContent tab))))
                                                             (first))]
                                  (when-not selected-tab-node
                                    (calculate-visible-elems state refs))

                                  (when-not dont-scroll-into-view?
                                    (when selected-tab-node
                                      (js/setTimeout (fn []
                                                       (.scrollIntoView selected-tab-node
                                                                        (clj->js
                                                                         {"behavior" "smooth" "block" "center" "inline" "center"}))
                                                       300))
                                      (js/setTimeout (fn []
                                                       (calculate-visible-elems state refs))
                                                     500)))
                                  (.addEventListener js/window "resize" resize-handler)))
      :component-will-unmount (fn []
                                (.removeEventListener js/window "resize" resize-handler))
      :reagent-render         (fn [{:keys [on-change! tabs selected-tab-key default-tab-key tab-strip-id]}]
                                (let [selected-tab (or selected-tab-key (:selected-tab @state))] 
                                  [:div
                                   {:class "hidden md:flex 
                                            border-b border-solid border-base-light-border-paler"
                                    :ref (fn [dom-node]
                                           (swap! refs assoc :tabstrip-dn dom-node))}
                                   (when-not (<= (count tabs) 4)
                                     [:div
                                      {:class-name (fu/cs (when-not (:left-arrow-visible? @state) "zap-tabstrip__arrow--disabled")
                                                          "zap-tabstrip__arrow zap-tabstrip__arrow--left")
                                       :on-click   (partial scroll-left state refs)}
                                      [:i.fa.fa-arrow-left]])
                                   [:div
                                    {:class "px-4 flex flex-1 overflow-hidden"
                                     :ref (fn [dom-node]
                                            (swap! refs assoc :container-dn dom-node))}
                                    [:ul 
                                     {:class "pt-2 flex gap-6"
                                      :ref (fn [dom-node]
                                             (swap! refs assoc :list-dn dom-node))}
                                     (->> tabs
                                          (map (fn [{:keys [tab-key tab-label] :as tab}]
                                                 [:li
                                                  {:key        (str "zap-tab-" tab-strip-id "-" tab-key)
                                                   :class-name (fu/cs "py-3  font-semibold text-base-light-text hover:text-base-light-text-accent cursor-pointer"
                                                                      (when (= selected-tab tab-key)
                                                                        "text-base-light-text-accent
                                                                         border-b-2 border-solid !border-base-light-border-accent"))
                                                   :on-click   (fn [_]
                                                                 (swap! state assoc :selected-tab tab-key)
                                                                 (on-change! tab-key))}
                                                  tab-label]))
                                          (doall))]]
                                   (when-not (<= (count tabs) 4)
                                     [:div
                                      {:class-name (fu/cs (when-not (:right-arrow-visible? @state) "zap-tabstrip__arrow--disabled")
                                                          "zap-tabstrip__arrow zap-tabstrip__arrow--right")
                                       :on-click   (partial scroll-right state refs)}
                                      [:i.fa.fa-arrow-right]])]))})))
